function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-6 -6)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48 48H0V0h48"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.558 7.037c12.722 0 15.577 9.75 15.577 18.373 0 8.61-6.98 15.59-15.59 15.59s-15.59-6.98-15.59-15.59C6.97 16.797 9.75 7.037 22.558 7.037z",
  stroke: "#666",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.75 31.913a7 7 0 01-10.277.082",
  stroke: "#E60000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.335 7.388s4.545 2.81 5.682 8.22",
  stroke: "#666",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 28.02,
  cy: 24.48,
  r: 1.27
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 28.02,
  cy: 24.48,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 17.48,
  cy: 24.52,
  r: 1.27
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 17.48,
  cy: 24.52,
  r: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.207 18.165L43 14",
  stroke: "#E60000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.625 18.75a17.75 17.75 0 012.088-5.375",
  stroke: "#666",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var SvgChildTrackerMid = function SvgChildTrackerMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 36",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgChildTrackerMid;